import { Controller } from "stimulus";
import { Dropzone } from "dropzone";
import disableElement from "../../functions/disableElement";
import enableElement from "../../functions/enableElement";
import hideElement from "../../functions/hideElement";
import showElement from "../../functions/showElement";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent";

export default class extends Controller {
  static get targets() {
    return ["dropzone", "hiddenField", "preview", "existingPreview"];
  }

  connect() {
    const dropzoneElement = new Dropzone(this.dropzoneTarget, this.options);

    dropzoneElement.on("addedfile", file => {
      hideElement(this.existingPreviewTarget);
      hideElement(this.dropzoneTarget);
      this.disableSubmitButtons();
      this.hiddenField.files = this.convertFile(file);
      this.enableSubmitButtons();

      if (this.autoSubmit) {
        dispatchCustomEvent(this.parentForm, "submit");
      }
    });

    dropzoneElement.on("removedfile", () => {
      this.disableSubmitButtons();
      this.hiddenField.value = null;
      this.enableSubmitButtons();
      showElement(this.dropzoneTarget);
      showElement(this.existingPreviewTarget);
    });
  }

  convertFile(file) {
    const transfer = new DataTransfer();
    transfer.items.add(file);
    return transfer.files;
  }

  disableSubmitButtons() {
    this.submitButtons.forEach(button => {
      disableElement(button);
    });
  }

  enableSubmitButtons() {
    this.submitButtons.forEach(button => {
      enableElement(button);
    });
  }

  get autoSubmit() {
    return this.dropzoneTarget.dataset.autoSubmit === "true";
  }

  get options() {
    return {
      url: this.parentForm.action,
      method: this.parentForm.method,
      autoProcessQueue: false,
      dictDefaultMessage: this.dropzoneTarget.dataset.placeholder,
      previewsContainer: this.previewTarget,
      acceptedFiles: this.dropzoneTarget.dataset.acceptedFiles,
      addRemoveLinks: true,
      maxFiles: 1
    };
  }

  get parentForm() {
    return this.hiddenFieldTarget.form;
  }

  get hiddenField() {
    return this.hiddenFieldTarget;
  }

  get submitButtons() {
    return this.parentForm.querySelectorAll("button[type=\"submit\"]");
  }
}
